<template>
  <v-container>
    <v-tabs v-model="tab">
      <v-tab>Vehicle</v-tab>
      <v-tab>Contributor</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="item in 2"
        :key="item"
      >
        <v-data-table
          :headers="tableHeaders"
          :items="tableData"
        >
          <template v-slot:item.rego="{ item }">
            <v-chip label>{{ item.rego }}</v-chip>
          </template>
          <template v-slot:item.maker="{ item }">
            <v-avatar size="36px" tile>
              <v-img
                :src="item.maker"
              ></v-img>
            </v-avatar>
          </template>
          <template v-slot:item.state="{ item }">
              <v-chip>
                {{ item.state }}
              </v-chip>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
export default {
  name: 'Leaderboard',
  data: () => ({
    tab: 0,
    tableHeaders: [
      {
        text: 'REGO',
        align: 'left',
        value: 'rego',
      },
      {
        text: 'MAKER',
        align: 'center',
        value: 'maker'
      },
      {
        text: 'STATE',
        align: 'center',
        value: 'state',
      },
      {
        text: 'COUNTS',
        align: 'left',
        value: 'offences',
      },
    ],
    tableData: [
      {
        rego: 'ABC123',
        maker: 'https://www.car-logos.org/wp-content/uploads/2011/10/holden.png',
        state: 'NSW',
        offences: 123,
      },
      {
        rego: 'ABC123',
        maker: 'https://www.car-logos.org/wp-content/uploads/2011/09/ford.png',
        state: 'SA',
        offences: 120,
      },
      {
        rego: 'ABC123',
        maker: 'https://www.car-logos.org/wp-content/uploads/2011/09/ferrari.png',
        state: 'WA',
        offences: 120,
      },
      {
        rego: 'ABC123',
        maker: 'https://www.car-logos.org/wp-content/uploads/2011/09/bmw.png',
        state: 'ACT',
        offences: 119,
      },
      {
        rego: 'ABC123',
        maker: 'https://www.car-logos.org/wp-content/uploads/2011/09/marchedrs.png',
        state: 'VIC',
        offences: 118,
      },
      {
        rego: 'ABC123',
        maker: 'https://www.car-logos.org/wp-content/uploads/2011/09/toyota.png',
        state: 'NT',
        offences: 117,
      },
      {
        rego: 'ABC123',
        maker: 'https://www.car-logos.org/wp-content/uploads/2011/09/volkswagen.png',
        state: 'TAS',
        offences: 117,
      },
    ]
  }),
};
</script>

<style scoped>

</style>
